export default "__VITE_ASSET__CTyvBdjl__"